<template>
    <div class="supportMains">
        <div class="buttonDiv">
            <a-button size="small" class="submitBtn" @click="submit">{{$t('support.submit')}}</a-button>
            <a-button size="small" class="submitBtn" @click="reset">{{$t('support.reset')}}</a-button>
        </div>
        <a-form :form="form">
            <a-col class="supportColumns">
                <a-row>
                    <a-form-item  class="genericFrom" >
                       <b>{{$t('support.c01MovePOToWarehousePO')}}</b>
                       <a-input size="small" ref="po" style="width: 300px" v-decorator="['po']" @pressEnter="submit"/>
                        <a-select size="small" ref="moveTo"  style="width: 325px;outline: none;text-align:center;text-align-last: center;padding-left: 5px" aria-selected="true" @change="toProjectChange">
                            <a-select-option value="1230">Move to HS SHANGHAI</a-select-option>
                            <a-select-option value="1231">Move to HS SHENZHEN</a-select-option>
                            <!--                    <a-select-option value="690">Move to HS BANGLADESH</a-select-option>-->
                            <a-select-option value="1232">Move to HS INDIA</a-select-option>
                            <!--                        <a-select-option value="procedure">Procedure</a-select-option>-->
                        </a-select>
                    </a-form-item>
                </a-row>
                <a-row class="noteColumns">
                    <b>{{$t('support.note')}}</b>
                    <div>
                        <a-textarea disabled v-model="note" class="noteText" style="color: black;height: 200px"/>
                    </div>
                </a-row>
            </a-col>
        </a-form>
    </div>
</template>
<script type="text/javascript">
    import Vue from 'vue'
    import VueResource from 'vue-resource'
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    Vue.use(VueResource)
    export default{
        props:{
            orgId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            projectId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            url: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        components:{
        },
        data(){
            return{
                form: this.$form.createForm(this, {}),
                type:"Move to HS SHENZHEN",
                supportType:"C01MovePOToWarehouse",
                toProjectId:'',
                note:"",
            }
        },
        methods:{
            submit(){
                if(null==this.$refs.po.value||this.$refs.po.value.length<=0){
                    this.note="请输入PO#";
                    return;
                }
                if(null==this.toProjectId||""==this.toProjectId){
                    this.note="请选择需要移库的Project";
                    return;
                }
                var params = {};
                params.supportType = this.supportType;
                params.po = this.$refs.po.value;
                params.orgId = this.orgId;
                params.projectId = this.projectId;
                params.toProjectId = this.toProjectId;
                params.url = this.url;//http://172.16.100.183:8099/TEST_SHAB2B_WMS/SupportServlet
                ajax.get(api.SENDSUPPORTC01MOVEPOTOWAREHOUSE,params).then(res=>{
                    if(res.code == 200){
                        this.note=this.$refs.po.value + "已成功转至SHENZHEN";
                        this.saveLog(params,"true","Succeed");
                    }else{
                        this.saveLog(params,"false",res.msg);
                        this.note=res.msg;
                    }
                })
            },
            saveLog(params,isSuccess,msg){
                let paramsLog = {
                    supportType: this.supportType,
                    params: JSON.stringify(params),
                    isSuccess: isSuccess,
                    returnMsg:msg
                }
                let that = this;
                ajax.get(api.SUPPORTSAVELOG,paramsLog).then(res=>{
                    if(res.code == 200){
                        that.$refs.po.value="";
                    }else{
                        that.note=res.msg;
                    }
                })
            },
            toProjectChange(val){
                this.toProjectId = val;
            },
            reset(){
                this.$refs.po.value="";
                this.$refs.moveTo.value="";
                this.note="";
            },
        }
    }
</script>